import React, { Suspense } from 'react'

const MoneyBackGuaranteeBase = React.lazy(() => import('./MoneyBackGuarantee'))

export const MoneyBackGuaranteePage = () => (
  <Suspense fallback={null}>
    <MoneyBackGuaranteeBase />
  </Suspense>
)
